/*
document.addEventListener('_changeVariant', function(event) {
  //console.log('Variant change')
});
*/

/*
document.addEventListener('cartItems', function(event) {
  //console.log('Cart has been updated')
});
*/

/* Kokon Pro: przeliczanie m² w koszyku po zmianie ilości */
(function () {
  function formatNumber(value, sep) {
    var rounded = Math.round(value * 100) / 100;
    return String(rounded).replace('.', sep || ',');
  }

  function refreshInput(input) {
    if (!input || !input.id) return;
    var key = input.id.replace('updates_', '');
    var boxes = document.querySelectorAll('.pack-info[data-key="' + key + '"]');
    boxes.forEach(function (box) {
      var area = parseFloat(box.getAttribute('data-pack-area'));
      var qty = parseInt(input.value, 10) || 0;
      var target = box.querySelector('.pack-total');
      if (!target || isNaN(area)) return;
      target.textContent = formatNumber(area * qty, box.getAttribute('data-sep'));
    });
  }

  function refreshAll() {
    document.querySelectorAll('input.item-qty').forEach(refreshInput);
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('input.item-qty')) refreshInput(e.target);
  });

  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches && e.target.matches('input.item-qty')) refreshInput(e.target);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.qtyplus_multi, .qtyminus_multi') : null;
    if (!btn) return;
    var input = document.getElementById(btn.getAttribute('field'));
    setTimeout(function () { refreshInput(input); }, 60);
    setTimeout(function () { refreshInput(input); }, 600);
  });

  document.addEventListener('cartItems', function () {
    setTimeout(refreshAll, 60);
  });
})();

/* Kokon Pro: tłumaczenie nazw filtrów (z tagów) w wersji angielskiej.
   Tagi produktów są po polsku i Shopify nie pozwala ich tłumaczyć,
   więc w wersji EN zamieniamy wyświetlany tekst według słownika.
   Nowy tag = dopisz go poniżej (klucz: polski tekst, wartość: angielski). */
(function () {
  var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
  if (lang.indexOf('en') !== 0) return;

  var dict = {
    'Grubość': 'Thickness',
    'Montaż': 'Installation',
    'Problem': 'Problem',
    'Na klej': 'Glued',
    'Na stelaż': 'On a stud frame',
    'Pod panele': 'Under laminate flooring',
    'Pod wykładzinę': 'Under carpet',
    'Nowa podłoga': 'New floor',
    'Zimna podłoga': 'Cold floor',
    'Odgłosy z góry': 'Noise from above',
    'Sąsiad zza ściany': 'Neighbour behind the wall',
    'Wyciszenie pokoju': 'Room soundproofing',
    'Wypełnienie wiszącego sufitu': 'Suspended ceiling infill'
  };

  function translateText(text) {
    var trimmed = text.trim();
    if (!trimmed) return null;
    var suffix = '';
    var core = trimmed;
    var m = trimmed.match(/^(.*?)(\s*(?:\.\.\.|…|:))$/);
    if (m && dict.hasOwnProperty(m[1].trim())) {
      core = m[1].trim();
      suffix = m[2];
    }
    if (!dict.hasOwnProperty(core)) return null;
    return text.replace(trimmed, dict[core] + suffix);
  }

  function translateNode(root) {
    if (!root) return;
    if (root.nodeType === 3) {
      var t = translateText(root.nodeValue);
      if (t !== null && t !== root.nodeValue) root.nodeValue = t;
      return;
    }
    if (root.nodeType !== 1) return;
    var tag = root.tagName;
    if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA') return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    var list = [];
    while ((node = walker.nextNode())) list.push(node);
    list.forEach(function (n) {
      var p = n.parentNode;
      if (p && (p.tagName === 'SCRIPT' || p.tagName === 'STYLE' || p.tagName === 'TEXTAREA')) return;
      var t = translateText(n.nodeValue);
      if (t !== null && t !== n.nodeValue) n.nodeValue = t;
    });
  }

  function run() {
    translateNode(document.body);
    var busy = false;
    var observer = new MutationObserver(function (mutations) {
      if (busy) return;
      busy = true;
      mutations.forEach(function (mu) {
        if (mu.type === 'characterData') {
          translateNode(mu.target);
        } else {
          mu.addedNodes.forEach(translateNode);
        }
      });
      busy = false;
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

/* Kokon Pro: kolejność liczbowa w filtrach (3 mm, 5 mm, 10 mm zamiast 10, 3, 5) */
(function () {
  function num(li) {
    var m = (li.textContent || '').trim().match(/^(\d+(?:[.,]\d+)?)/);
    return m ? parseFloat(m[1].replace(',', '.')) : null;
  }
  function sortLists() {
    document.querySelectorAll('ul.advanced-filters').forEach(function (ul) {
      var items = Array.prototype.slice.call(ul.children).filter(function (li) { return li.tagName === 'LI'; });
      if (items.length < 2) return;
      if (!items.every(function (li) { return num(li) !== null; })) return;
      var sorted = items.slice().sort(function (a, b) { return num(a) - num(b); });
      var same = sorted.every(function (li, i) { return li === items[i]; });
      if (same) return;
      sorted.forEach(function (li) { ul.appendChild(li); });
    });
  }
  function run() {
    sortLists();
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(sortLists, 50);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();